
import { defineComponent, ref, onMounted, nextTick } from "vue";
import { configure, ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { PasswordMeterComponent, MenuComponent } from "@/assets/ts/components";
import { reinitializeComponents } from "@/core/plugins/keenthemes";
import { useGtm } from "@gtm-support/vue-gtm";
import AuthAside from "@/components/page-layouts/AuthAside.vue";
import LanguageSelect from "@/components/dropdown/LanguageSelect.vue";
import { useI18n } from "vue-i18n";
import useLocale from "@/core/common/useLocale";

export default defineComponent({
  name: "sign-up",
  components: {
    Field,
    Form,
    ErrorMessage,
    AuthAside,
    LanguageSelect,
  },
  inject: ["ismobile"],
  setup() {
    const store = useStore();
    const router = useRouter();
    const gtm = useGtm();
    const i18n = useI18n();
    const { t } = i18n;

    function triggerEvent(message) {
      gtm?.trackEvent({
        event: message,
      });
    }

    const userEmail = ref(store.getters.userEmail);
    const submitButton = ref<HTMLFormElement | null>(null);
    const password = ref("password");
    const password_confirmation = ref("password");
    const age_confirmation = ref("checkbox");

    const registration = Yup.object().shape({
      email: Yup.string()
        .min(4)
        .required(t("Email is a required field"))
        .email(t("emailValidation"))
        .label(t("Email")),
      password: Yup.string()
        .matches(/[1-9]+/, t("Use number"))
        .matches(/[a-z]+/, t("Use lowercase character"))
        .matches(/[A-Z]+/, t("Use uppercase character"))
        .matches(
          /[!"#$%&'()*+,-./:;<=>?@[\]^_'{|}~]+/,
          t("Use special character")
        )
        .min(12, t("Password must be at least 12 characters"))
        .required(t("Password is a required field"))
        .label(t("Password")),
      password_confirmation: Yup.string()
        .required(t("Password is a required field"))
        .oneOf(
          [Yup.ref("password"), null],
          t("The password and its confirm are not the same")
        )
        .label(t("Password Confirmation")),
      age_confirmation_checkbox: Yup.boolean()
        .required(t("This is a required field"))
        .label(t("This")),
      signup_checkbox: Yup.boolean()
        .required(t("This is a required field"))
        .label(t("This")),
    });

    onMounted(() => {
      nextTick(() => {
        PasswordMeterComponent.bootstrap();

        nextTick(() => {
          reinitializeComponents();
        });
      });
    });

    const onSubmitRegister = async (values) => {
      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      configure({
        validateOnBlur: false, // controls if `blur` events should trigger validation with `handleChange` handler
        validateOnChange: false, // controls if `change` events should trigger validation with `handleChange` handler
        validateOnInput: false, // controls if `input` events should trigger validation with `handleChange` handler
        validateOnModelUpdate: true, // controls if `update:modelValue` events should trigger validation with `handleChange` handler
      });

      // eslint-disable-next-line
      submitButton.value!.disabled = true;

      // Activate indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      // Send login request
      await store.dispatch(Actions.REGISTER, values);

      /*const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName];*/
      const userExist = store.getters.isExistUserCheck;

      console.log(userExist);
      if (userExist) {
        localStorage.setItem("email", values.email);
        triggerEvent("sign_up_success");

        router.push({ name: "onboarding" });
      } else {
        triggerEvent("sign_up_fail");
        Swal.fire({
          text: t("User already exist."),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("Try again!"),
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }

      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };
    function showPassword(t) {
      console.log(t);
      if (t == "password") {
        if (password.value === "password") {
          password.value = "text";
        } else {
          password.value = "password";
        }
      } else if (t == "password_confirmation") {
        if (password_confirmation.value === "password") {
          password_confirmation.value = "text";
        } else {
          password_confirmation.value = "password";
        }
      }
    }
    return {
      userEmail,
      showPassword,
      password,
      password_confirmation,
      registration,
      onSubmitRegister,
      submitButton,
      triggerEvent,
      ...useLocale(),
    };
  },
});
